import React   , {useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import ValidationButton from "../ValidationButton";
import Box from "@mui/material/Box";
import PreviewButton from "../PreviewButton";
import { useDispatch, useSelector } from "react-redux";
import {completeTask, getTask} from "../../../store/action/taskAction";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImagesTab from "../../sinistreSection/photoSection";
import PropTypes from "prop-types";
import { BsUpload } from 'react-icons/bs';
import { createFinancialDocument, updateServiceProposal } from '../../../store/action/claimManagement';
import {addMetaDataToFile, uploadFile, deleteFileImage } from '../../../store/action/fileManagement';
import {TailSpin} from "react-loader-spinner";
import {useNavigate, useParams} from "react-router-dom";
import ErrorsAlert from "../../../utils/errorsAlert";
import PreviewPDF from '../PreviewPDF';
import MaskedDecimalInput from "../../../utils/MaskedDecimalInput";
import { toast } from "react-toastify";

const commonButtonStyle = {
    fontFamily: 'Poppins',
    fontSize: '10.76px',
    fontWeight: 600, 
    border: 'none',
    cursor: 'pointer',
    opacity: '0px',
    borderRadius: '5.38px', 
};
const annulerStyle = {
    ...commonButtonStyle,
    width: 'fit-content',
    height: '36px',
    backgroundColor: 'rgba(229, 234, 238, 1)',
    color: 'rgb(225, 31, 31)', 
    marginRight : '20px'
};
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    paper: {
        // display: "flex",
        borderRadius: "11px",
        width: "100%",
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        //paddingTop: "0px"
    },
    paper1: {
        display: 'flex',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    leftSection: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        flexDirection: 'column'
    },
    rightSection: {
        flex: 1,
        padding: '20px',
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputTextArea: {
        width: '100%',
        marginBottom: '20px',
    },
    uploadRectangle: {
        width: '519px',
        height: '374px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        cursor: 'pointer',
        opacity: 0.8,
        backgroundColor: 'rgba(243, 246, 249, 1);',
    },
    uploadTextPrimary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '24px',
        color: 'rgba(60, 101, 86, 1)',
        marginTop: '10px',
    },
    uploadTextSecondary: {
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '23px',
        textAlign: 'center',
        color: 'rgba(128, 128, 143, 1)',
        marginTop: '5px',
    },
    hiddenInput: {
        display: 'none',
    },
    AffectedSection: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        justifyContent: "center"
    },
    //popup:
    titre: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(63, 66, 84, 1)',
    },
    titreLabel: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(32, 18, 70, 1)',
    },
    tablePagination: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        color: 'rgba(32, 18, 70, 1)'
    },
    dateRangeContainer: {
        display: 'flex',
        alignItems: 'center',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        padding: '5px 10px',
    },
    dateContainer: {
        border: 'none',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: '100%',
        height: '36px',
        borderRadius: 4,
        marginBottom: '20px',
    },
    dialogPaper: {
        width: '1300px',
        overflow: 'hidden',
        background: 'rgb(243, 246, 249)',
    },
    dialogTitle: {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: 18,
        color: 'rgba(63, 66, 84, 1)',
        backgroundColor: 'white',
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
    },

    dialogContent: {
        overflowY: 'auto',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    closeButton: {
        cursor: 'pointer',
        color: 'rgba(32, 18, 70, 1)',
        marginLeft: 1051,
    },
    //for the preview btn
    previewBtn:{
        position: 'absolute',
        background: 'rgb(243, 246, 249)',
        right: '-5px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div style={{ width: "100%", background: 'rgba(255, 255, 255, 1)' }}>
                    {children}
                </div>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const UploadInvoiceAndPictures = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();

    const classes = useStyles();
    const dispatch = useDispatch();

    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const username = localStorage.getItem('username');
    const [testImages, setTestImages] = useState(false);
    const taskReducer = useSelector((state) => state.taskReducer?.taskList?.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    useEffect(() => {
        const fetchTask = async () => {
            try {
                const response = await getTask(taskId, username);
                setTask(response)
                setInfoSinistre(response?.businessKey)
                setVariables(response?.variables)
                setProposedServiceCamunda(response.variables?._proposedService?.value)
                setClaimNumber(response?.businessKey)
            } catch (error) {
                console.error(`Error fetching task details: ${error.message}`);
            }
        };
        fetchTask();
    }, [dispatch, taskId, username]);

    const [variables, setVariables] = useState(task?.variables)
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)

    const [claimNumber, setClaimNumber] = useState(task?.businessKey);
    console.log("claimNumber", claimNumber)
    const [value, setValue] = useState(0);
    const [uid, setUid] = useState('');
    const [existComplementaryQuote, setExistComplementaryQuote] = useState(false);
    const [totalAmountWOTax, setTotalAmountWOTax] = useState('0.000');
    const [totalAmountWTax, setTotalAmountWTax] = useState('0.000');
    const [estimatedEntryDate, setEstimatedEntryDate] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const proposedServiceId = task?.variables?._proposedServiceId?.value 

    const proposedServiceCamundaReducer = useSelector((state) => state.taskReducer?.taskList?.find(task => task?.taskId === taskId)?.variables?._proposedService?.value);
    const [proposedServiceCamunda, setProposedServiceCamunda] = useState(proposedServiceCamundaReducer)
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);
    const [openPreviewPDF, setOpenPreviewPDF] = useState(false);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task]);

    const validateInputs = () => {
        const validationErrors = [];

        if (!uid) {
            validationErrors.push("Veuillez télécharger la facture");
        }

        if (!totalAmountWOTax || isNaN(parseFloat(totalAmountWOTax))) {
            validationErrors.push("Le montant total HT est requis et doit être un nombre valide");
        } else if (!parseFloat(totalAmountWOTax) > 0) {
            validationErrors.push("Le montant total HT ne peut pas être null");
        }

        if (!totalAmountWTax || isNaN(parseFloat(totalAmountWTax))) {
            validationErrors.push("Le montant total TTC est requis et doit être un nombre valide");
        } else if (!parseFloat(totalAmountWTax) > 0) {
            validationErrors.push("Le montant total TTC ne peut pas être null");
        }

        if (totalAmountWOTax && totalAmountWTax &&
            parseFloat(totalAmountWTax) < parseFloat(totalAmountWOTax)) {
            validationErrors.push("Le montant TTC doit être supérieur ou égal au montant HT");
        }

        if ((task?.variables?.managementType?.value === "-500") && 500 < parseFloat(totalAmountWTax) ) {
        validationErrors.push("Le montant TTC ne doit pas dépasser 500 DT pour le dossier -500.");
         }

        if (!(task?.variables?.managementType?.value === "RGA" ||
                task?.variables?.managementType?.value === "AUTOP" ||
                task?.variables?.managementType?.value === "AfriqueAssistance") &&
            !estimatedEntryDate) {
            validationErrors.push("La date de réparation est requise");
        }
        if(!testImages){
            validationErrors.push("Merci d'ajouter les photos avant et après la réparation.");
        }

        return validationErrors;
    };

    const handleInvoiceValidation = async () => {
        const financialDocument = {
            type: existComplementaryQuote ?'QUOTATION':'INVOICE',
            associatedClaimNumber:task.businessKey, 
            associatedDocument: uid,
            totalAmountWOTax: parseFloat(totalAmountWOTax),
            totalAmountWTax: parseFloat(totalAmountWTax), 
        };

        if (task && task.variables && task.variables.claimExpertId) {
            financialDocument.status = 'RECEIVED';
        } else {
            financialDocument.status = 'VALID';
        }

        const serviceProposal = {
            proposedService: proposedServiceCamunda,
            estimatedCarDeposalDate: estimatedEntryDate,
        };
        try {
            await dispatch(createFinancialDocument(financialDocument)); 
        } catch (error) {
            console.error('Error creating financial document:', error);
        }
        if(!task.variables.managementType.value === "RGA" && !task.variables.managementType.value === "AUTOP" && !task?.variables?.managementType?.value === "AfriqueAssistance"){
            try {
                await updateServiceProposal(proposedServiceId, serviceProposal); 
            } catch (error) {
                console.error('Error updating service proposal:', error);
            }
        }
    };

    const ValidationAction = async () => {
        const validationErrors = validateInputs();

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        await handleInvoiceValidation();
        try {
            //let variables = {};
            setVariables(variables.existComplementaryQuote = {
                value: existComplementaryQuote,
                type: 'Boolean',
            });
            await dispatch(completeTask(taskId, username, variables));
            navigate('/todo-list', { reload: true });
        } catch (error) {
            console.error(error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        }
    }

    const handleUploadClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleFileChange = async (event) => {
        setLoading(true);

        const file = event.target.files[0];
        if (!file) {
            setLoading(false);
            return;
        }

        const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            toast.error("Seuls les fichiers PDF et images (JPEG, PNG) sont acceptés");
            setLoading(false);
            return;
        }

        const fileUrl = URL.createObjectURL(file);
        setPdfUrl(fileUrl);

        const formData = new FormData();
        formData.append('fileUploaded', file);
        formData.set('createdBy', username);
        formData.set('key', 'NUM_SIN');
        formData.set('value', claimNumber);
        try {
            const response = await dispatch(uploadFile(formData));
            const uid = response.uid;
            setUid(uid);

            const metaData = {
                key: 'TYPE_DOCUMENT',
                value: 'INVOICE',
            };
            await dispatch(addMetaDataToFile(uid, metaData));
            setRefresh(!refresh);
        } catch (error) {
            console.error(error);
            toast.error("Une erreur est survenue lors de l'ajout du fichier");
        } finally {
            setLoading(false);
        }
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
    
        // Allow empty string or valid number with up to 3 decimal digits
        const regex = /^\d*(\.|,)?\d{0,3}$/;
    
        // Normalize comma to dot
        const normalizedValue = value.replace(',', '.');
    
        if (regex.test(normalizedValue)) {
            if (name === 'totalAmountWOTax') {
                setTotalAmountWOTax(normalizedValue);
            } else if (name === 'totalAmountWTax') {
                setTotalAmountWTax(normalizedValue);
            }
        }
    };

    const handleDeleteFile = async () => {
        setPdfUrl(null);
        setUid(null);
        try {
            await dispatch(deleteFileImage(uid));
            setRefresh(!refresh);
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    };

    return (
        <div className={classes.root}>
            
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed}/>

                <Paper className={classes.paper}>
                    <Tabs value={value} sx={{ marginTop: "10px", marginLeft: "10px", variant: "fullWidth" }} onChange={handleChange}>
                        <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(0)} label="Upload Photos" />
                        <Tab sx={{ textTransform: 'none', height: 50, fontFamily: 'Poppins', fontSize: '13px', fontWeight: 600, lineHeight: '19.5px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.35)', color: 'rgba(63, 66, 84, 0.64)', marginRight: '5px' }} {...a11yProps(1)} label="Upload Facture" />
                    </Tabs>

                    <CustomTabPanel value={value} index={0}>
                         <ImagesTab claimNumber={claimNumber} isTaskClaimed={isTaskClaimed} setTestImages ={setTestImages} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <Paper className={classes.paper1}>
                        <div className={classes.leftSection}>
    {pdfUrl ? (
        <><div className={classes.uploadRectangle}>
                                            <div className={classes.uploadTextPrimary}>
                                                Prévisualiser votre facture
                                            </div>
                                            {loading ? (
                                                <TailSpin color="rgba(187, 200, 8, 1)" radius={"10px"} />
                                            ) : (
                                                <div style={{ position: 'relative', width: '375px', height: '325px' }}>
                                                <iframe
                                                    src={pdfUrl}
                                                    width="375"
                                                    height="325"
                                                    title="PDF Viewer"
                                                    style={{ pointerEvents: 'none' }}
                                                />
                                                <div
                                                    onClick={() => {
                                                        if (pdfUrl) {
                                                            setOpenPreviewPDF(true);
                                                        }
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        cursor: 'pointer',
                                                        backgroundColor: 'transparent',
                                                    }}
                                                ></div>
                                            </div>
                                            )}

                                        </div><button
                                            style={annulerStyle}
                                            onClick={() => {
                                                handleDeleteFile();
                                            } }
                                        >
                                                Supprimer le fichier
                                            </button></>
    ) : (
        <div className={classes.uploadRectangle} onClick={handleUploadClick}>
            <BsUpload style={{ color: 'rgba(60, 101, 86, 1)' }} size={40} />
            <div className={classes.uploadTextPrimary}>
                Ajoutez votre facture
            </div>
            <div className={classes.uploadTextSecondary}>
                Déposez votre facture{" "}
                <u style={{ color: 'rgba(60, 101, 86, 1)' }}>parcourir</u> un
                fichier <br /> depuis votre ordinateur.
            </div>
            <input
                id="fileInput"
                type="file"
                accept="image/*,application/pdf"
                className={classes.hiddenInput}
                disabled={isTaskClaimed}
                onInput={handleFileChange}
            />
        </div>
    )}
</div>

                            <div className={classes.rightSection}>
                                <div>
                                <label className={classes.inputLabel}>Total des réparations Sans Tax</label>
                                    <MaskedDecimalInput
                                        className={classes.inputContainer}
                                        name="totalAmountWOTax"
                                        disabled={isTaskClaimed}
                                        value={totalAmountWOTax}
                                        onChange={(value) => setTotalAmountWOTax(value)}
                                    />
                                </div>
                                <div>
                                    <label className={classes.inputLabel}>Total des réparations TTC</label>
                                    <MaskedDecimalInput
                                        className={classes.inputContainer}
                                        name="totalAmountWTax"
                                        disabled={isTaskClaimed}
                                        value={totalAmountWTax}
                                        onChange={(value) => setTotalAmountWTax(value)}
                                    />
                                </div>
                                {(task?.variables?.managementType?.value === "RGA" || task?.variables?.managementType?.value === "AUTOP" || task?.variables?.managementType?.value === "AfriqueAssistance")?
                                <></>:
                                 
                                <div>
                                    <label className={classes.inputLabel}>Date de réparation</label>
                                    <input
                                        type="date"
                                        min={task?.variables?.openingDate?.value}
                                        className={classes.inputContainer}
                                        name="estimatedEntryDate"
                                        disabled={isTaskClaimed}
                                        value={estimatedEntryDate}
                                        onChange={(e) => setEstimatedEntryDate(e.target.value)}
                                    />
                                </div>}
                                { task?.variables?.managementType?.value === "RGA"?
                                <div>
                                <label className={classes.inputLabel}>Avez-vous ajouté un devis complémentaire ?</label>
                                <div>
                                    <input
                                        type="radio"
                                        id="yes"
                                        name="additionalDevis"
                                        value="yes"
                                        checked={existComplementaryQuote}
                                        disabled={isTaskClaimed}
                                        onChange={() => setExistComplementaryQuote(true)}
                                    />
                                    <label htmlFor="yes">Oui</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="no"
                                        name="additionalDevis"
                                        value="no"
                                        checked={!existComplementaryQuote}
                                        disabled={isTaskClaimed}
                                        onChange={() => setExistComplementaryQuote(false)}
                                    />
                                    <label htmlFor="no">Non</label>
                                </div>
                            </div>:<></>}
                            </div>
                        </Paper>
                    </CustomTabPanel>
                </Paper>
            </div>
            <PreviewButton claimData={infoSinistre}  />
            </div>
            <ValidationButton
                handleValidation={() => isTaskClaimed ? null : ValidationAction()}
            />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        <PreviewPDF pdfUrl={pdfUrl} open={openPreviewPDF} onClose={() => setOpenPreviewPDF(false)} />

        </div>
    );
};

export default UploadInvoiceAndPictures;
